/*
 * @Author: Cphayim
 * @Date: 2019-06-28 15:56:52
 * @LastEditTime: 2019-06-28 15:57:55
 * @Description: Element
 */

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

export default ElementUI
